import {
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  GoldOutlined,
  TableOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const auditoria: MenuConfigItem[] = [
  {
    label: "PAINEL GERAL",
    key: "/painelGeral",
    path: "/painelGeral",
    icon: <DashboardOutlined />,
  },
  {
    label: "SORTEIO",
    key: "/sorteioPai",
    path: "/sorteioPai",
    icon: <CalendarOutlined />,
    children: [
      {
        label: "SORTEIOS",
        key: "/sorteio",
        path: "/sorteio",
      },
      {
        label: "CONDIÇÕES GERAIS",
        key: "/condicaoGeralSorteio",
        path: "/condicaoGeralSorteio",
      },
      {
        label: "GRADES DE PREMIAÇÃO",
        key: "/gradePremiacao",
        path: "/gradePremiacao",
      },
      {
        label: "TIPOS DE SORTEIO",
        key: "/tipoSorteio",
        path: "/tipoSorteio",
      },
      {
        label: "ANEXOS",
        key: "/anexos",
        path: "/anexos",
      },
    ],
  },
  {
    label: "FINANCEIRO",
    key: "/financeiro",
    path: "/financeiro",
    icon: <DollarCircleOutlined />,
    children: [
      {
        label: "CONTAS A PAGAR",
        key: "/contaPagar",
        path: "/contaPagar",
      },
      {
        label: "CONTAS A RECEBER",
        key: "/contaReceber",
        path: "/contaReceber",
      },
      // {
      //   label: "CONTA RECORRENTE",
      //   key: "/contaRecorrente",
      //   path: "/contaRecorrente",
      // },
      {
        label: "AUDITORIA DE CONTAS FINANCEIRAS",
        key: "/auditoria",
        path: "/auditoria",
      },
      {
        label: "LANÇAMENTOS FINANCEIROS",
        key: "/lancamentoFinanceiro",
        path: "/lancamentoFinanceiro",
      },
      {
        label: "FECHAMENTO FINANCEIRO",
        key: "/fechamentoFinanceiro",
        path: "/fechamentoFinanceiro",
      },
    ],
  },
  {
    label: "FINANCEIRO TÁTICO",
    key: "/financeiroTatico",
    path: "/financeiroTatico",
    icon: <GoldOutlined />,
    children: [
      {
        label: "PLANO DE CONTA FINANCEIRO",
        key: "/planoContaFinanceiro",
        path: "/planoContaFinanceiro",
      },
      {
        label: "PLANO DE CONTA CONTÁBIL",
        key: "/planoContaContabil",
        path: "/planoContaContabil",
      },
      {
        label: "GRUPO DE PLANO DE CONTA FINANCEIRO",
        key: "/grupoPlanoContaFinanceiro",
        path: "/grupoPlanoContaFinanceiro",
      },
      {
        label: "CENTROS DE CUSTO",
        key: "/centroCusto",
        path: "/centroCusto",
      },
      {
        label: "RATEIOS DE CENTRO DE CUSTO",
        key: "/rateioCentroCusto",
        path: "/rateioCentroCusto",
      },
      {
        label: "CONTAS BANCÁRIAS",
        key: "/contaBanco",
        path: "/contaBanco",
      },
      {
        label: "BANCOS",
        key: "/banco",
        path: "/banco",
      },
      {
        label: "FORMA DE PAGAMENTO",
        key: "/formaPagamentoRecebimento",
        path: "/formaPagamentoRecebimento",
      },
      {
        label: "GRUPO DE CONTA BANCÁRIA",
        key: "/grupoContaBanco",
        path: "/grupoContaBanco",
      },
    ],
  },
  {
    label: "RESULTADOS",
    key: "/resultados",
    path: "/resultados",
    icon: <BarChartOutlined />,
    children: [
      {
        label: "RESULTADO DO SORTEIO",
        key: "/resultadoSorteio",
        path: "/resultadoSorteio",
      },
      {
        label: "ENTRE FASES",
        key: "/comparativoEmpresa",
        path: "/comparativoEmpresa",
      },
      {
        label: "ENTRE EMPRESAS",
        key: "/comparativoResultadoEmpresa",
        path: "/comparativoResultadoEmpresa",
      },
      {
        label: "COMPOSIÇÃO DE RESULTADO DA EMPRESA",
        key: "/composicao",
        path: "/composicao",
      },
      {
        label: "CONFIGURAÇÕES PONTO DE EQUILÍBRIO",
        key: "/configuracoesPonto",
        path: "/configuracoesPonto",
      },
    ],
  },
  {
    label: "RELATÓRIOS",
    key: "/relatorios",
    path: "/relatorios",
    icon: <FilePdfOutlined />,
    children: [
      {
        label: "CONTAS BANCÁRIAS",
        key: "/relatorioContaBancaria",
        path: "/relatorioContaBancaria",
      },
      {
        label: "CONTAS BANCÁRIAS CONSOLIDADAS",
        key: "/relatorioConsolidadoSaldoBancario",
        path: "/relatorioConsolidadoSaldoBancario",
      },
      {
        label: "LANÇAMENTOS",
        key: "/relatorioLancamentos",
        path: "/relatorioLancamentos",
      },
    ],
  },
  {
    label: "CONSIGNATÁRIOS",
    key: "/consignatarios",
    path: "/consignatarios",
    icon: <UserOutlined />,
    children: [
      {
        label: "CARTEIRA DOS CONSIGNATÁRIOS",
        key: "/lancamentoConsignatario",
        path: "/lancamentoConsignatario",
      },
      {
        label: "CONTROLE DE COMPROVANTES DOS CONSIGNATÁRIOS",
        key: "/controleComprovanteConsignatario",
        path: "/controleComprovanteConsignatario",
      },
      {
        label: "IMPORTAÇÃO DAS VENDAS DOS CONSIGNATÁRIOS",
        key: "/importacaoVendaConsignatario",
        path: "/importacaoVendaConsignatario",
      },
      {
        label: "SALDO CONSIGNATÁRIOS",
        key: "/relatorioSaldoConsignatario",
        path: "/relatorioSaldoConsignatario",
      },
      {
        label: "CRÉDITOS DOS CONSIGNATÁRIOS",
        key: "/relatorioCreditosConsignatario",
        path: "/relatorioCreditosConsignatario",
      },
      {
        label: "NOTAS FISCAIS",
        key: "/notasFiscais",
        path: "/notasFiscais",
      },
      {
        label: "CONFIGURAÇÃO DE IMPORTAÇÃO DAS VENDAS",
        key: "/configuracaoImportacaoVenda",
        path: "/configuracaoImportacaoVenda",
      },
    ],
  },
  {
    label: "IMPOSTO",
    key: "/imposto",
    path: "/imposto",
    icon: <BankOutlined />,
    children: [
      {
        label: "IMPOSTOS E TAXAS",
        key: "/impostosTaxas",
        path: "/impostosTaxas",
      },
      {
        label: "PERFIL DE TAXA/IMPOSTO",
        key: "/perfilTaxaImposto",
        path: "/perfilTaxaImposto",
      },
      {
        label: "TIPOS DE TAXAS/IMPOSTOS",
        key: "/tipoTaxaImposto",
        path: "/tipoTaxaImposto",
      },
    ],
  },
  {
    label: "GERAL",
    key: "/geral",
    path: "/geral",
    icon: <FileProtectOutlined />,
    children: [
      {
        label: "EMPRESAS",
        key: "/empresa",
        path: "/empresa",
      },
      {
        label: "CONSIGNATÁRIOS",
        key: "/consignatario",
        path: "/consignatario",
      },
      {
        label: "PESSOAS",
        key: "/pessoa",
        path: "/pessoa",
      },
      {
        label: "FERIADOS",
        key: "/feriado",
        path: "/feriado",
      },
      {
        label: "TIPO DOCUMENTO",
        key: "/tipoDocumento",
        path: "/tipoDocumento",
      },
    ],
  },
];
